<template>
  <v-form lazy-validation>
    <Input
      :data="{
        text:
          this.user.car.maketext !== undefined
            ? this.text.registrationplate + ': ' + this.user.car.maketext + ' ' + this.user.car.modeltext + ''
            : this.text.registrationplate,
        name: 'registrationplate',
        onkeyup: false,
        onblur: true,
        value: this.user.registrationplate,
        rules: this.user.errors.registration !== '' ? this.registrationplateErrorRules : this.registrationplateRules
      }"
      v-on:childToParent="inputPlatesChange"
    />
    <CustomVehicleSelectors />
    <Number
      ref="numberInput"
      :data="{
        text: this.text.kilometers,
        name: 'kilometers',
        onkeyup: true,
        onblur: false,
        value: this.user.kilometers,
        router: 'Service',
        rules: this.kilometersRules
      }"
      v-on:childToParent="inputKmChange"
    />
  </v-form>
</template>

<script>
import Vue from 'vue';
import localizationTexts from '@/localization/texts.json';
import Input from '@/components/fragments/input.vue';
import Number from '@/components/fragments/number.vue';
import CustomVehicleSelectors from '@/components/CustomVehicleSelectors.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'LookupInformation',
  watch: {
    token: {
      handler: function (newtoken) {
        if (newtoken && this.yesSetCarAfterTokenHack) {
          this.setCar(this);
        }
      }
    }
  },
  data() {
    return {
      yesSetCarAfterTokenHack: false,
      registrationplate: '',
      kilometers: 0,
      text: {
        registrationplate: '',
        kilometers: ''
      },
      registrationplateRules: [
        (v) => !!v || localizationTexts[this.user.config.language].validation.missing.registrationPlate,
        (v) => (v && v.length > 1) || localizationTexts[this.user.config.language].validation.specific.registrationPlateLength
      ],
      registrationplateErrorRules: [(v) => !v || this.user.errors.registration],
      kilometersRules: [
        (v) => !!v || localizationTexts[this.user.config.language].validation.missing.kilometers,
        (v) => (v && v > 0) || localizationTexts[this.user.config.language].validation.specific.kilometersLength
      ]
    };
  },
  mounted() {
    this.text.registrationplate = localizationTexts[this.user.config.language].pageIntro.licenseplate;
    this.text.kilometers = localizationTexts[this.user.config.language].pageIntro.drivenKilometers;
  },
  updated() {
    if (this.registrationplate !== this.registrationplate.trim()) {
      this.registrationplate = this.registrationplate.trim();
    }
  },
  components: {
    CustomVehicleSelectors,
    Input,
    Number
  },
  methods: {
    setCar: (that) => {
      that.$store.dispatch('errors/resetErrors', 'registration');
      if (that.user.rooftopids.length > 0) {
        const payload = {
          endpoint: that.user.config.parameters.api + '/maintenance/GetVehicleData',
          params: {
            token: that.user.token,
            traceid: that.user.guid,
            rooftopids: that.user.rooftopids,
            registrationplate: that.user.registrationplate,
            culture: that.user.config.parameters.parameters.culture,
            test: that.user.config.parameters.parameters.test
          }
        };
        that.$store.dispatch('user/initCar', payload).then(() => {
          // carbrands does NOT have Other
          if (that.user.carbrands.length > 0 && !that.user.carbrands.includes('OTHER')) {
            if (
              that.user.car.maketext != '' &&
              that.user.carbrands.length > 0 &&
              that.user.carbrands.includes(that.user.car.maketext.toUpperCase()) &&
              that.user.car.registrationplate !== undefined
            ) {
              that.setEligableDepartments(that);
              that.$store.dispatch('errors/resetErrors', 'registration');
            } else if (that.user.carbrands.length > 0 && !that.user.carbrands.includes(that.user.car.maketext.toUpperCase())) {
              that.$store.dispatch('user/initErrors', {
                endpoint: 'registration',
                data: localizationTexts[that.user.config.language].validation.specific.noEligableDepartments,
                error: localizationTexts[that.user.config.language].validation.specific.noEligableDepartments
              });
            }
          } else if (that.user.car.registrationplate !== undefined) {
            if (that.user.car.maketext !== '') {
              that.setEligableDepartments(that);
              that.$store.dispatch('errors/resetErrors', 'registration');
            }
          }
        });
      } else {
        that.registrationplate = '';
        that.kilometers = 0;
        that.$store.dispatch('user/initRegistrationPlate', '');
        that.$store.dispatch('user/initLoading', false);
      }
    },
    setEligableDepartments: (that) => {
      that.$store.dispatch('errors/resetErrors', 'departments');
      that.$store.dispatch('user/initCheckToken').then(() => {
        if (!that.user.tokenexpired) {
          const payload = {
            endpoint: that.user.config.parameters.api + '/department/eligable',
            params: {
              rooftopids: that.user.rooftopids,
              traceid: that.user.guid,
              makename: that.user.car.maketext,
              test: that.user.config.parameters.parameters.test
            }
          };
          if (that.registrationplate !== '') {
            that.$store.dispatch('user/initListEligableDepartments', payload).then(() => {
              that.setDepartments(that);
            });
          }
        }
      });
    },
    setDepartments: (that) => {
      if (that.user.lists.departments.eligable.length > 0) {
        that.$store.dispatch('user/initListDepartments').then(() => {
          that.$store.dispatch('user/initLoading', false);
          if (that.user.lists.departments.output.length > 0 && that.registrationplate !== '') {
            that.user.lists.departments.output.forEach((item) => {
              that.setCarMake(that, item);
            });
          }
        });
      } else {
        that.$store.dispatch('user/initLoading', false);
      }
    },
    setCarMake: (that, item) => {
      const payloadMake = {
        endpoint: that.user.config.parameters.api + '/maintenance/GetMakeData',
        params: {
          token: that.user.token,
          traceid: that.user.guid,
          makename: that.user.car.maketext,
          culture: that.user.config.parameters.parameters.culture,
          rooftopid: item.rooftopid,
          test: that.user.config.parameters.parameters.test
        }
      };
      if (that.registrationplate !== '') {
        that.$store.dispatch('user/initCarDetailMake', payloadMake).then(() => {
          that.setServicesList(that, item);
          if (that.user.car.makecode !== '') {
            that.setCarModel(that, item);
          }
        });
      }
    },
    setCarModel: (that, item) => {
      const payloadModel = {
        endpoint: that.user.config.parameters.api + '/maintenance/GetModelData',
        params: {
          token: that.user.token,
          traceid: that.user.guid,
          makecode: that.user.car.makecode,
          modelName: that.user.car.modeltext,
          culture: that.user.config.parameters.parameters.culture,
          rooftopid: item.rooftopid,
          test: that.user.config.parameters.parameters.test
        }
      };
      if (that.registrationplate !== '') {
        that.$store.dispatch('user/initCarDetailModel', payloadModel).then(() => {
          that.setCarVariant(that, item);
        });
      }
    },
    setCarVariant: (that, item) => {
      const payloadVariant = {
        endpoint: that.user.config.parameters.api + '/maintenance/GetVariantData',
        params: {
          token: that.user.token,
          traceid: that.user.guid,
          makecode: that.user.car.makecode,
          modelcode: that.user.car.modelcode,
          culture: that.user.config.parameters.parameters.culture,
          rooftopid: item.rooftopid,
          test: that.user.config.parameters.parameters.test
        }
      };
      if (that.registrationplate !== '') {
        that.$store.dispatch('user/initCarDetailVariant', payloadVariant);
      }
    },
    setServicesList: (that, item) => {
      that.$store.dispatch('user/initCheckToken').then(() => {
        if (!that.user.tokenexpired) {
          const payload = {
            endpoint: that.user.config.parameters.api + '/maintenance/services',
            params: {
              token: that.user.token,
              traceid: that.user.guid,
              rooftopid: item.rooftopid,
              cultureName: that.user.config.parameters.parameters.culture,
              makecode: item.car.makecode,
              estodometer: that.user.car.estodometer,
              registrationplate: that.user.car.registrationplate,
              disableservicecomments: that.user.config.parameters.parameters.disableservicecomments
            }
          };
          that.$store.dispatch('user/initListServices', payload).then(() => {
            if (that.user.lists.departments.output.length === 1) {
              const data = {
                change: true,
                response: that.user.lists.departments.output[0]
              };
              that.$store.dispatch('user/initDepartment', data);
            } else if (that.user.selectedRooftopid !== undefined && that.user.selectedRooftopid !== '') {
              let filtered = that.user.lists.departments.output.filter(function (item) {
                return item.rooftopid === that.user.selectedRooftopid;
              });
              if (filtered.length === 1) {
                const data = {
                  change: true,
                  response: filtered[0]
                };
                that.$store.dispatch('user/initDepartment', data);
              }
            }
            that.$store.dispatch('user/initLoading', false);
          });
        }
      });
    },
    inputKmChange(payload) {
      this.kilometers = Math.floor(payload);
      let kilometers = Math.floor(payload);
      this.$store.dispatch('user/initKilometers', kilometers).then(() => {
        this.$store.dispatch('user/initLoading', true);
        this.$store.dispatch('user/initLoading', false);
      });
    },
    inputPlatesChange(payload) {
      this.$refs.numberInput.setFocus();
      this.$store.dispatch('user/initLoading', true);
      this.registrationplate = payload.trim().toUpperCase();
      this.$store.dispatch('user/initRegistrationPlate', payload.trim().toUpperCase());
      this.$store.dispatch('user/initCarReset');
      this.$store.dispatch('user/initListCarMakesManualReset');
      if (payload.trim().length > 0) {
        this.$store.dispatch('user/initCheckToken').then(() => {
          if (!this.user.tokenexpired) {
            if (this.token) {
              this.setCar(this);
            } else {
              this.yesSetCarAfterTokenHack = true;
            }
          }
        });
      } else {
        this.$store.dispatch('user/initLoading', false);
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    token() {
      return this.$store.getters['user/user'].token;
    }
  }
});
</script>

<style scoped lang="scss"></style>

<i18n src="../localization/texts.json"></i18n>
